var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBlack = function SvgLogoBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 64,
    viewBox: "0 0 195 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4929 12.3596L0.150329 45.8585C-0.162745 46.403 0.0278212 47.1108 0.58591 47.3966C11.7341 53.1408 25.5365 49.1662 31.8797 38.195L51.7939 3.70239C40.4824 -2.81771 26.0266 1.04807 19.4929 12.3596Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9784 3.71564L19.5057 5.18826L26.2721 11.9546L27.7447 10.482L20.9784 3.71564Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9212 6.26148C20.6502 6.26148 22.0519 4.8598 22.0519 3.13074C22.0519 1.40168 20.6502 0 18.9212 0C17.1921 0 15.7904 1.40168 15.7904 3.13074C15.7904 4.8598 17.1921 6.26148 18.9212 6.26148Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3349 24.1883V62.9006C16.3349 63.5267 16.8521 64.044 17.4919 64.0032C30.0149 63.4042 39.9924 53.0592 39.9924 40.3865V0.530823C26.9113 0.530823 16.3349 11.1209 16.3349 24.1883Z",
    fill: "#0190F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6173 24.1883C23.6173 33.2266 30.9405 40.5498 39.9788 40.5498V7.82681C30.9405 7.82681 23.6173 15.15 23.6173 24.1883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5708 28.4352L39.9788 24.1747V40.5362C47.0025 40.5362 52.9782 36.1124 55.3058 29.8917C55.5236 29.2928 55.1969 28.6258 54.5708 28.4352Z",
    fill: "#FF9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3295 16.4568C59.1307 7.18705 50.3238 0.530823 39.9788 0.530823V24.1747L61.5945 17.8724C62.1934 17.6954 62.5473 17.0557 62.3295 16.4568Z",
    fill: "#FF9A07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2001 20.0095C34.6359 20.0095 35.7999 18.8455 35.7999 17.4096C35.7999 15.9737 34.6359 14.8097 33.2001 14.8097C31.7642 14.8097 30.6002 15.9737 30.6002 17.4096C30.6002 18.8455 31.7642 20.0095 33.2001 20.0095Z",
    fill: "#07133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.322 12.3976H94.6134C103.313 12.3976 109.023 17.0196 109.023 25.0671C109.023 33.1147 103.368 37.6823 94.6134 37.6823H83.4664V52.0374H77.3764V12.3976H77.322ZM94.4503 32.2991C100.16 32.2991 102.878 29.5259 102.878 25.1215C102.878 20.6627 100.16 17.8896 94.4503 17.8896H83.4664V32.3535H94.4503V32.2991Z",
    fill: "#111D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.567 38.0085C109.567 28.3296 116.907 23.164 124.629 23.164C132.296 23.164 139.636 28.3296 139.636 38.0085C139.636 47.6873 132.296 52.853 124.629 52.853C116.907 52.853 109.567 47.6873 109.567 38.0085ZM133.709 38.0085C133.709 32.2447 129.523 28.5471 124.629 28.5471C119.681 28.5471 115.494 32.2447 115.494 38.0085C115.494 43.7723 119.681 47.4698 124.629 47.4698C129.523 47.4698 133.709 43.7723 133.709 38.0085Z",
    fill: "#111D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.185 12.3976H144.313V52.0374H150.185V12.3976Z",
    fill: "#111D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.474 12.3976H156.602V52.0374H162.474V12.3976Z",
    fill: "#111D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89 63.4019L169.815 58.0187C170.576 58.3449 171.283 58.5624 172.207 58.5624C173.784 58.5624 174.817 57.7468 175.524 55.7893L176.938 52.2005L165.41 23.9252H172.044L180.037 44.0442L187.867 23.9252H194.501L180.799 57.6924C179.004 62.1512 176.394 64 172.479 64C171.12 64 169.869 63.7825 168.89 63.4019Z",
    fill: "#111D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194.447,
    height: 64,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoBlack.9712db31a85fe3b192cdfa9baf5328e2.svg";